import differenceInCalendarDays from "date-fns/differenceInCalendarDays";

import parseDate from "date-fns/parse";

import { formatString } from "../keluarga";

export function countAge(tgl_lahir) {
  const days = differenceInCalendarDays(
    new Date(),
    parseDate(tgl_lahir, formatString, new Date())
  );
  const years = days / 365;
  return parseInt(years);
}

export function countAgeMonth(tgl_lahir) {
  const days = differenceInCalendarDays(
    new Date(),
    parseDate(tgl_lahir, formatString, new Date())
  );

  const month = days / 30.41;
  return parseInt(month);
}

function haveChildren(keluarga) {
  return keluarga.some((value) => {
    return value.sts_hubungan === "3";
  });
}

function haveChildrenWithSingelParent(keluarga) {
  return keluarga.some((value) => {
    // console.log(value, "VALUE KELUARGA >>>")
    // console.log(keluarga, "KELUARGA >>>")

    if (keluarga[0].sts_kawin === "3" || keluarga[0].sts_kawin === "4") {
      // console.log("A");
      return false; // TIDAK BERALKU
    } else if (value.sts_hubungan === "3") {
      if (
        keluarga[0].jenis_kelamin === "1" &&
        keluarga[0].sts_kawin !== "2" &&
        (+value.kd_ibukandung === 0 ||
          +value.kd_ibukandung === 1 ||
          +value.kd_ibukandung === 2 ||
          +value.kd_ibukandung === "" ||
          !value.kd_ibukandung)
      ) {
        console.log("B");
        return false; // TIDAK BERLAKU
      } else if (
        keluarga[0].jenis_kelamin === "2" &&
        keluarga[0].sts_kawin !== "2" &&
        (+value.kd_ibukandung === 0 ||
          +value.kd_ibukandung === 1 ||
          +value.kd_ibukandung === 2)
      ) {
        console.log("C");
        return false; // TIDAK BERLAKU
      } else {
        console.log("D");
        return true; // YA & TIDAK
      }
    }
  });
}

function haveWifeOrHusband(keluarga) {
  return keluarga.some((value) => {
    return value.sts_hubungan === "2";
  });
}

function haveChildrenUnder5(keluarga) {
  return keluarga.some((value) => {
    // if (value.sts_hubungan === "3") {
    // const days = differenceInCalendarDays(new Date(), new Date(value.tgl_lahir));
    const month = countAgeMonth(value.tgl_lahir); //days / 365;
    if (month <= 60) {
      return true;
    }
    // }
    // return false;
  });
}

function haveChildrenUnder6(keluarga) {
  return keluarga.some((value) => {
    //if (value.sts_hubungan === "3") {
    // const days = differenceInCalendarDays(new Date(), new Date(value.tgl_lahir));
    const month = countAgeMonth(value.tgl_lahir); //days / 365;
    if (month <= 72) {
      return true;
    }
    //}
    //return false;
  });
}

function haveChildrenFrom10To24(keluarga) {
  return keluarga.some((value) => {
    if (value.sts_hubungan === "3") {
      // const days = differenceInCalendarDays(new Date(), new Date(value.tgl_lahir));
      const month = countAgeMonth(value.tgl_lahir); //days / 365;
      //console.log(years);
      if (month >= 120 && month <= 288) {
        //console.log('true')
        return true;
      }
    }
    return false;
  });
}

function haveFamilyMember60(keluarga) {
  return keluarga.some((value) => {
    // const days = differenceInCalendarDays(new Date(), new Date(value.tgl_lahir));
    const month = countAgeMonth(value.tgl_lahir); //days / 365;
    let umur = month / 12;
    // if (month > 720) {
    if (umur >= 60) {
      return true;
    }
    return false;
  });
}

function haveMarriedMember(keluarga) {
  return keluarga.some((value) => {
    return value.sts_kawin === "2";
  });
}

function haveChildrenFrom0To17(keluarga) {
  return keluarga.some((value) => {
    if (value.sts_hubungan === "3") {
      // const days = differenceInCalendarDays(new Date(), new Date(value.tgl_lahir));
      const years = countAge(value.tgl_lahir); //days / 365;
      if (years >= 0 && years <= 17) {
        return true;
      }
    }
    return false;
  });
}

function PeopleInHome(keluarga) {
  return keluarga.some((value) => {
    if (value.keberadaan === "1") {
    }
    return false;
  });
}

export default {
  haveChildren,
  haveWifeOrHusband,
  haveChildrenUnder5,
  haveChildrenUnder6,
  haveChildrenFrom10To24,
  haveFamilyMember60,
  haveMarriedMember,
  haveChildrenFrom0To17,
  haveChildrenWithSingelParent,
  PeopleInHome,
};
